import React from "react";
import { Table } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import { currencyFormat } from "../lib/utils";
import { IOrderProduct } from "../types/api";

const ProductDetails = ({
    product: p,
    orderNumber,
}: {
    product: IOrderProduct;
    orderNumber?: number;
}): React.ReactNode => {
    const location = useLocation();
    const isOnLeagueManagement = /league-management/.test(location.pathname);

    return (
        <Table
            borderless
            className="productDetails"
            data-testid="productDetails"
        >
            <thead>
                <tr>
                    <th colSpan={2}>{p.description}</th>
                </tr>
            </thead>
            <tbody>
                {!isOnLeagueManagement && orderNumber && (
                    <tr>
                        <td>
                            <h5>Order Number:</h5>
                        </td>
                        <td>{orderNumber}</td>
                    </tr>
                )}
                <tr>
                    <td>
                        <h5>Cost:</h5>
                    </td>
                    <td>{currencyFormat.format(p.orderPrice)}</td>
                </tr>
                <tr>
                    <td>
                        <h5>New or Returning Team:</h5>
                    </td>
                    <td>{p.meta.teamType}</td>
                </tr>
                <tr>
                    <td>
                        <h5>Team Name</h5>
                    </td>
                    <td>{p.meta.teamName}</td>
                </tr>
                {isOnLeagueManagement && (
                    <tr>
                        <td>
                            <h5>Team Id:</h5>
                        </td>
                        <td>{p.meta.teamId}</td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
};

export default ProductDetails;
